import { ExclamationCircleFilled } from '@ant-design/icons'
import { Button, Col, Modal, Row } from 'antd'
import './ModalConfirm.style.less'

interface Props {
  open: boolean
  title: string
  content: JSX.Element
  cancelButtonText?: string
  confirmButtonText?: string
  onClose: () => void
  onCancel?: () => void
  onOK: () => void
  type?: string
  loading?: boolean
  maskClosable?: boolean
  noIcon?: boolean
}

function ModalConfirm(props: Props) {
  const { maskClosable = true } = props
  const backgrouncColor = () => {
    if (props.type == 'delete') return '#c03261'
    return '#ef9747'
  }

  return (
    <Modal
      className="modal-confirmation-container"
      maskClosable={maskClosable}
      open={props.open}
      footer={false}
      width={500}
      onCancel={props.onClose}
    >
      <Row align={'top'}>
        {!props.noIcon && (
          <Col span={2}>
            <ExclamationCircleFilled
              className="icon"
              style={{ color: backgrouncColor() }}
            />
          </Col>
        )}

        <Col span={props.noIcon ? 24 : 22}>
          <p className="title">{props?.title}</p>
          <div className="content">{props.content}</div>
          <Row justify={'end'} className="button-container">
            <Button
              className="cancel-button"
              disabled={props?.loading ?? false}
              onClick={props.onCancel ?? props.onClose}
              size="large"
            >
              {props.cancelButtonText ?? 'Cancel'}
            </Button>
            <Button
              onClick={props.onOK}
              loading={props?.loading ?? false}
              disabled={props?.loading ?? false}
              size="large"
              style={{ backgroundColor: backgrouncColor() }}
              type="primary"
            >
              {props.confirmButtonText ?? 'Confirm'}
            </Button>
          </Row>
        </Col>
      </Row>
    </Modal>
  )
}

export default ModalConfirm
